module.exports = __webpack_public_path__ + "f25c0da9240a7ba7ff61cb2371f51e47.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Avenir-Light.woff?v=8.0d5e4
// module id = 930
// module chunks = 24